import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import HeroSection from '../components/home/HeroSection';
import FeatureSection from '../components/home/FeatureSection';
import Section from '../components/common/Section';
import Button from '../components/common/Button';
import { Link } from 'react-router-dom';

const StatsContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 2rem;
  margin: 3rem 0;
`;

const StatItem = styled.div`
  text-align: center;
`;

const StatNumber = styled.div`
  font-size: 3rem;
  font-weight: 700;
  color: ${props => props.theme.colors.primary};
  margin-bottom: 0.5rem;
`;

const StatLabel = styled.div`
  font-size: 1.1rem;
  color: ${props => props.theme.colors.lightText};
`;

const CTASection = styled.div`
  background: linear-gradient(135deg, ${props => props.theme.colors.primary} 0%, #004E8C 100%);
  color: white;
  text-align: center;
  padding: 4rem 2rem;
  border-radius: ${props => props.theme.borderRadius.medium};
  margin-top: 4rem;
`;

const CTATitle = styled.h3`
  font-size: 2rem;
  margin-bottom: 1.5rem;
`;

const CTAText = styled.p`
  font-size: 1.1rem;
  max-width: 800px;
  margin: 0 auto 2rem;
  opacity: 0.9;
`;

const Home = () => {
  const { t } = useTranslation();

  return (
    <>
      <HeroSection />
      <FeatureSection />

      <Section
        title={t('home.whyChoose')}
        subtitle={t('home.whyChooseSubtitle')}
        bgColor="white"
      >
        <StatsContainer>
          <StatItem>
            <StatNumber>10+</StatNumber>
            <StatLabel>{t('home.stats.years')}</StatLabel>
          </StatItem>
          <StatItem>
            <StatNumber>100+</StatNumber>
            <StatLabel>{t('home.stats.clients')}</StatLabel>
          </StatItem>
          <StatItem>
            <StatNumber>200+</StatNumber>
            <StatLabel>{t('home.stats.projects')}</StatLabel>
          </StatItem>
          <StatItem>
            <StatNumber>15+</StatNumber>
            <StatLabel>{t('home.stats.countries')}</StatLabel>
          </StatItem>
        </StatsContainer>

        {/* <CTASection>
          <CTATitle>{t('home.ctaTitle')}</CTATitle>
          <CTAText>{t('home.cta')}</CTAText>
          <Link to="/contact" className="bg-black text-white hover:bg-gray-800 font-bold py-2 px-4 rounded transition-colors duration-200"> {t('contact.title')} </Link>
        </CTASection> */}
        <div className='flex bg-gray-100 m-1 rounded-xl flex-col py-[40px] justify-center items-center '>
          <CTATitle>{t('home.ctaTitle')}</CTATitle>
          <CTAText>{t('home.cta')}</CTAText>
          <Link to="/contact" className="bg-black text-white hover:bg-gray-800 font-bold py-2 px-4 rounded transition-colors duration-200"> {t('contact.title')} </Link>
        </div>
      </Section>
    </>
  );
};

export default Home;